import { useCallback, type UIEvent } from 'react';

import { app } from 'core';
import { useRedirectToHome } from 'ui/hooks/useRedirectToHome';

export function useEventGoogleAnalytics() {
  const { trackClick } = app.commands.useAppCommand();
  const { redirectToHome } = useRedirectToHome();
  const handleClickToHome = useCallback((event: UIEvent<HTMLButtonElement>) => {
    trackClick(event);
    redirectToHome();
  }, []);

  const trackUserClicks = useCallback((event: UIEvent<HTMLButtonElement>) => {
    trackClick(event);
  }, []);

  return [handleClickToHome, trackUserClicks];
}
